import type { AppError } from "./types";

/**
 * Checks if the given value is an AppError instance.
 * @param value unknown value to check
 * @returns boolean indicating whether the value is an AppError
 */
export function isAppError(value: unknown): value is AppError {
  
  if (typeof value !== "object" || value === null) {
    return false;
  }

  const candidate = value as Partial<AppError>;

  return (
    candidate.name === "AppError" &&
    typeof candidate.kind === "string" &&
    typeof candidate.message === "string" &&
    typeof candidate.userMessage === "string"
  );
}
